export default __webpack_public_path__ + "static/media/voglia_di_pizza.83503f04.png";